export const sessionTrace = {
  enabled: true,
  load_public_functions: true,
  harvester: false,
  sampling: 1.0,
};
